import { rest } from 'utils';

export default {
  create: ({ user }) => rest.post({ url: 'um/users', body: user }),
  get: ({ id }) => rest.get({ url: `um/users/${id}?depth=2` }),
  getAll: () => rest.get({ url: 'um/users?depth=1' }),
  update: ({ id, user }) => rest.put({ url: `um/users/${id}`, body: user }),
  delete: ({ id }) => rest.delete({ url: `um/users/${id}` }),
  getAllResources: () => rest.get({ url: 'um/resources?depth=1' }),
  getGroupsForUser: ({ userId }) => rest.get({ url: `um/users/${userId}/groups?depth=1` }),
  getAllS3Keys: ({ userId }) => rest.get({ url: `/um/users/${userId}/s3keys?depth=2` }),
  createS3Key: ({ userId }) => rest.post({ url: `/um/users/${userId}/s3keys` }),
  deleteS3Key: ({ userId, keyId }) => rest.delete({ url: `/um/users/${userId}/s3keys/${keyId}` }),
  updateS3KeyActiveState: ({ userId, keyId, active }) => rest.put({
    url: `/um/users/${userId}/s3keys/${keyId}`,
    body: {
      properties: {
        active,
      },
    },
  }),
};
